
import { Cloudinary } from "cloudinary-core";
export const CloudinaryCore = new Cloudinary({ cloud_name: "jeff-fitness" });

export const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/jeff-fitness/upload";
export const CLOUDINARY_UPLOAD_PRESET_CHAT = "km9n9u8j";
export const CLOUDINARY_UPLOAD_PRESET_POST = "v3kujpzi";


